module.exports = __webpack_public_path__ + "static/img/dxf1.c13f470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/dxf1.png
// module id = IPA9
// module chunks = 53